<template>
	<form class="wrap--xsm__left margin-b-150" @submit.prevent="submitSelection">

		<div class="col-12 margin-b-75">

			<label>Navn på gruppen?</label>

			<input class="col-12" type="text" name="name" placeholder="Hvad er navnet på tilkøbet?" minlength="2" maxlength="120" required v-model="newSelection.title">

		</div>

		<div class="col-12">

			<button class="btn btn--md btn--secondary secondary--grey" :disabled="!validateTitle|| isSaving || shouldLock">

				<span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

				<span>Gem gruppe</span>

			</button>

		</div>

	</form>
</template>

<script>
	import {mapGetters} from 'vuex';
    export default {
        name: "extraSelectionForm",
		props:['selection', 'shouldLock'],
        data(){
            return {
                newSelection:{
                    title:'',
                },
                isSaving:false,
				isCreating:false,
            };

        },
        computed:{
			...mapGetters({
				product:'product',
			}),
			validateTitle(){
                return this.newSelection.title !== '' && String(this.newSelection.title).length > 0;
			},
        },
		methods:{
            submitSelection(){
                if(this.isSaving){
                    return;
				}

				if(this.isCreating){
				    return this.createSelection();
				}

				this.updateSelection();
			},
			createSelection(){
				this.isSaving = true;
				const data = {
				    title: this.newSelection.title,
					min_options: 0,
					max_options: 0,
					price:0,
				};
				axios.post(`/api/admin/product/${this.product.id}/extra/selection`, data).then(response => {
				    this.newSelection = {
                        title:'',
                    };
				    this.isSaving = false;
				    this.$emit('completed', response.data.data);
				});
			},
			updateSelection(){
                this.isSaving = true;
                const data = {
                    title: this.newSelection.title,
                    min_options: 0,
                    max_options: 0,
					price:0,
                };
				axios.put(`/api/admin/product/${this.product.id}/extra/selection/${this.selection.id}`, data).then(response=>{
                    this.isSaving = false;
                    data.id = this.selection.id;
                    data.isUpdating = true;
                    this.$emit('completed', data);
				});
			}
		},
		created(){
            if(this.selection){
                return this.newSelection = this.selection;
			}

			this.isCreating = true;
		}
    }
</script>

<style scoped>

</style>
